import router, { RouteItemType } from '~/core/router';
import PrivacyPolicyPage from '~/projects/polyllm-chat/components/LegalPage/components/PrivacyPolicyPage';
import SubscriptionTermsPage from '~/projects/polyllm-chat/components/LegalPage/components/SubscriptionTermsPage';
import TermsOfUsePage from '~/projects/polyllm-chat/components/LegalPage/components/TermsOfUsePage';

const PrivacyPolicyPath = '/legal/privacy-policy';
const SubscriptionTermsPath = '/legal/subscription-terms';
const TermsOfUsePath = '/legal/terms-of-use';

const getPrivacyTitle = (): string => 'Privacy Policy';
const getSubscriptionTermsTitle = (): string => 'Subscription Terms';
const getTermsTitle = (): string => 'Terms of Use';

const LegalRoutes: RouteItemType[] = [
  {
    Component: PrivacyPolicyPage,
    path: PrivacyPolicyPath,
    getTitle: getPrivacyTitle,
  },
  {
    Component: SubscriptionTermsPage,
    path: SubscriptionTermsPath,
    getTitle: getSubscriptionTermsTitle,
  },
  {
    Component: TermsOfUsePage,
    path: TermsOfUsePath,
    getTitle: getTermsTitle,
  },
];

router.addUnAuthorizedRoutes(LegalRoutes);
